import React, { useMemo } from "react";
import { Item } from "../../components/Menu";
import { MenuItem } from "../../components/Menu";
import { useCommunicationHandlers } from "../UsefulLinks";
import { LocalizationMessages } from "../../localization/messages";

const HelpWidgetMenu = () => {
  const { handleHelpCenter } = useCommunicationHandlers();
  const helpItem = useMemo(
    () =>
      new Item({
        title: LocalizationMessages.helpCenter,
        iconKey: "help"
      }),
    []
  );

  return (
    <MenuItem item={helpItem} onClick={handleHelpCenter} dataTestId="uc-help" />
  );
};

export default HelpWidgetMenu;
